import { Alert, Text } from '@mantine/core';

import { ApiError } from '../api/client';

/**
 * What the deployment is missing, by the code the server refuses with. The
 * server's own message says what is off; this names the variable that turns
 * it on, which the message cannot, since the library it comes from does not
 * know which app it is in.
 */
const missing: Record<string, string> = {
  NO_CORPUS: 'RAG_EMBED_API_KEY',
  NO_SECRET_KEY: 'MINDVM_SECRET_KEY',
};

/** The code a refusal carries, if it is an API refusal at all. */
export function refusalCode(err: unknown): string | undefined {
  return err instanceof ApiError ? err.problem.code : undefined;
}

/** A failed call, shown as the server put it — plus the variable to set, when that is the cause. */
export function Refusal({ error }: { error: unknown }) {
  if (!error) return null;
  const message = error instanceof Error ? error.message : String(error);
  const code = refusalCode(error);
  const variable = code ? missing[code] : undefined;
  return (
    <Alert color={variable ? 'yellow' : 'red'} variant="light" title={variable ? 'Not configured' : undefined}>
      <Text size="sm">{message}</Text>
      {variable && (
        <Text size="sm" mt={4}>
          Set <code>{variable}</code> on the server to enable this.
        </Text>
      )}
    </Alert>
  );
}
